import React, { useState, useEffect } from "react";
import styled from "styled-components";
import assets from "../../../assets/assets";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { mn } from "date-fns/locale";
import { IconController } from "../../Scripts/ImgController";
import { getMonth, setMonth, sub, subMonths } from "date-fns";
import Ripples from "react-ripples";
import useIsMobile from "../../Scripts/useIsMobile";
import { mobileBottomSheet, mobileOverlay } from "../../Scripts/mobileBottomSheet";
const Wrapper = styled.div`
  border: 1px solid black;
  border-radius: 99px;
  cursor: pointer;
`;
const Popup = styled.div`
  position: absolute;
  top: 90px;
  z-index: 103 !important;

  .modal {
    width: 425px;
    background: #ffffff;
    border: 1px solid #f3f4f6;
    box-shadow: 0px 20px 25px -5px rgba(0, 0, 0, 0.1),
      0px 10px 10px -5px rgba(0, 0, 0, 0.04);
    border-radius: 12px;
    display: flex;
    flex-direction: column;
  }
  .date-container {
    display: inline-block;
  }
  .input-container {
    position: relative;
  }
  .react-datepicker {
    border: none;
    font-family: "Montserrat", sans-serif;
  }
  .date-a11y {
    border-right: 1px solid #e5e7eb;
  }
  .date-a11y span {
    padding: 8px;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
  }
  .date-a11y span.date-active {
    background: linear-gradient(
      270deg,
      rgba(0, 97, 255, 0.2) 0%,
      rgba(0, 97, 255, 0) 100%
    );
    border-right: 3px solid #0061ff;
  }
  .dateshde:hover {
    background: linear-gradient(
      270deg,
      rgba(0, 97, 255, 0.2) 0%,
      rgba(0, 97, 255, 0) 100%
    );
  }
  .date-clear-field {
    border-top: 1px solid #e5e7eb;
  }
  .react-datepicker {
    width: 100%;
    height: 100%;
  }
  .react-datepicker__month-container {
    width: 100%;
    height: 100%;
  }
  .react-datepicker__navigation-icon::before {
    content: none;
  }
  .react-datepicker__navigation-icon {
    background-image: url(${assets.svg.prevMonth});
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    width: 32px;
    height: 32px;
    left: 10px;
    top: 3px;
  }
  .react-datepicker__navigation--next .react-datepicker__navigation-icon {
    background-image: url(${assets.svg.nextMonth});
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    width: 32px;
    height: 32px;
    right: 10px;
    top: 3px;
  }
  .react-datepicker__navigation--next {
    right: 10px;
    top: 3px;
  }
  .react-datepicker__header {
    background: none;
    padding-top: 8px;
  }
  .react-datepicker__current-month {
    padding-top: 8px;
  }
  .react-datepicker__navigation {
    overflow: visible;
  }
  .react-datepicker__day-name {
    font-size: 12px;
    font-weight: 600;
  }
  .react-datepicker__day--in-selecting-range:not(
      .react-datepicker__day--in-range,
      .react-datepicker__month-text--in-range,
      .react-datepicker__quarter-text--in-range,
      .react-datepicker__year-text--in-range
    ),
  .react-datepicker__month-text--in-selecting-range:not(
      .react-datepicker__day--in-range,
      .react-datepicker__month-text--in-range,
      .react-datepicker__quarter-text--in-range,
      .react-datepicker__year-text--in-range
    ),
  .react-datepicker__quarter-text--in-selecting-range:not(
      .react-datepicker__day--in-range,
      .react-datepicker__month-text--in-range,
      .react-datepicker__quarter-text--in-range,
      .react-datepicker__year-text--in-range
    ),
  .react-datepicker__year-text--in-selecting-range:not(
      .react-datepicker__day--in-range,
      .react-datepicker__month-text--in-range,
      .react-datepicker__quarter-text--in-range,
      .react-datepicker__year-text--in-range
    ) {
    background: #60a5fa;
    border-radius: 8px;
    font-weight: 600;
  }
  .react-datepicker__day--selected:hover {
    background: #60a5fa;
    border-radius: 8px;
    font-weight: 600;
  }
  .react-datepicker__day--selected {
    background: #60a5fa;
    border-radius: 8px;
    font-weight: 600;
  }
  .react-datepicker__day--in-range {
    background: #60a5fa;
    border-radius: 8px;
    font-weight: 600;
  }
  .react-datepicker__month .react-datepicker__month-text,
  .react-datepicker__month .react-datepicker__quarter-text {
    width: 5.5rem;
    height: 60px;
    font-size: 16px;
    text-align: center;
    padding-top: 18px;
  }
  .react-datepicker__month-text--disabled {
    cursor: not-allowed;
  }
  ${mobileBottomSheet(".modal")}
`;
const Overlay = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 102 !important;
  top: 0;
  left: 0;
  ${mobileOverlay}
`;
const DateSelectDropdown = ({
  setDateFilter,
  newRequest,
  setNewRequest,
  width,
  setCKPopup,
  setCKPopupType,
  setCKPopupMessage,
  minDate,
}) => {
  const dateOptions = [
    { title: "1 сар", days: 1 },
    { title: "3 сар", days: 3 },
    { title: "6 сар", days: 6 },
  ];
  const [popup, setPopup] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState("----/--");
  const [selectedEndDate, setSelectedEndDate] = useState("----/--");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(null);
  const [dateA11y, setDateA11y] = useState("");
  const [canSort, setCanSort] = useState(true);
  const isMobile = useIsMobile();

  useEffect(() => {
    daySelectHandler(6);
  }, []);

  const checkDateNotExceeded = (a1, a2, a3, b1, b2, b3) => {
    const date1 = new Date(a1 + "/" + a2 + "/" + a3);
    const date2 = new Date(b1 + "/" + b2 + "/" + b3);
    const monthsDiff =
      (date2.getFullYear() - date1.getFullYear()) * 12 +
      (date2.getMonth() - date1.getMonth());
    return monthsDiff >= 6;
  };
  const onCalendarChange = (dates) => {
    const [start, end] = dates;
    const filteredStartDate = new Date(start);
    const filteredEndDate = new Date(end);

    const newStartDate = new Date(
      filteredStartDate.getFullYear(),
      filteredStartDate.getMonth(),
      filteredStartDate.getDate()
    );
    const newEndDate = new Date(
      filteredEndDate.getFullYear(),
      filteredEndDate.getMonth(),
      filteredEndDate.getDate()
    );

    const startYear = newStartDate.getFullYear();
    const startMonth = newStartDate.getMonth() + 1; // January is 0, so you may want to add 1 to match human-readable month numbering
    const startDay = newStartDate.getDate();
    const endYear = newEndDate.getFullYear();
    const endMonth = newEndDate.getMonth() + 1; // January is 0, so you may want to add 1 to match human-readable month numbering
    const endDay = newEndDate.getDate();
    setStartDate(start);
    setEndDate(end);
    // Carickao: ene deed 2 zuvhun calendar deer haruulahiig udirddag
    if (end !== null) {
      if (
        checkDateNotExceeded(
          startYear,
          startMonth,
          startDay,
          endYear,
          endMonth,
          endDay
        )
      ) {
        setCanSort(false);
        setCKPopupType("Warning");
        setCKPopupMessage("dateExceeded");
        setCKPopup(true);
      } else {
        setSelectedStartDate(startYear + "/" + startMonth);
        setSelectedEndDate(endYear + "/" + endMonth);
        // Carickao: ene deed 2 zuvhun ter haruulj baigaa string g udirddag
        setDateFilter(
          "filter[date][starts]=" +
            startYear +
            "-" +
            startMonth +
            "-" +
            startDay +
            "&filter[date][ends]=" +
            endYear +
            "-" +
            endMonth +
            "-" +
            endDay
        );
        setDateA11y("chosen");
        setCanSort(true);
      }
    }
  };

  const daySelectHandler = (days) => {
    setDateA11y(days);
    const dateMinusOne = addDays(new Date(), -1);
    const date = subMonths(dateMinusOne, --days);
    setCanSort(true);
    setSelectedStartDate(date.getFullYear() + "/" + (date.getMonth() + 1));
    setSelectedEndDate(
      dateMinusOne.getFullYear() + "/" + (dateMinusOne.getMonth() + 1)
    );
    // Carickao: ene deed 2 zuvhun ter haruulj baigaa string g udirddag
    setStartDate(new Date(date.getFullYear(), date.getMonth(), date.getDate()));
    setEndDate(dateMinusOne);
    // Carickao: ene deed 2 zuvhun calendar deer haruulahiig udirddag
    setDateFilter(
      "filter[date][starts]=" +
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        1 +
        "&filter[date][ends]=" +
        dateMinusOne.getFullYear() +
        "-" +
        (dateMinusOne.getMonth() + 1) +
        "-" +
        dateMinusOne.getDate()
    );
    // Carickao: ene deed 2 parent div ruugee array aar damjuulj date ugdug
  };

  const clearHandler = () => {
    setCanSort(false);
    setSelectedStartDate("----/--/--");
    setSelectedEndDate("----/--/--");
    // Carickao: ene deed 2 zuvhun ter haruulj baigaa string g udirddag
    setStartDate(null);
    setEndDate(null);
    // Carickao: ene deed 2 zuvhun calendar deer haruulahiig udirddag

    // Carickao: ene deed 2 parent div ruugee array aar damjuulj date ugdug
    setDateA11y("");
  };

  const sortHandler = async () => {
    if (canSort) {
      setNewRequest(!newRequest);
      setPopup(false);
    } else {
      setCKPopupType("Warning");
      setCKPopupMessage("dateExceeded");
      setCKPopup(true);
    }
  };

  const handleOpen = () => {
    setPopup(true);
  };
  const addDays = (date, days) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + days);
    return newDate;
  };
  return (
    <>
      <Ripples color="#0061FF40" during={600} className="rounded-2xl w-full">
        <Wrapper style={{ width: isMobile ? "100%" : width + "px" }}>
          <div
            className="flex flex-row justify-center items-center px-2"
            onClick={() => {
              handleOpen();
            }}
          >
            <div className="pr-2">
              <IconController src={assets.svg.calendar} alt="" />
            </div>
            <div className="flex-1">
              <span className="font-medium text-xs">
                {selectedStartDate} - {selectedEndDate}{" "}
              </span>
            </div>
            <div className="pl-2">
              <IconController src={assets.svg.chevronDown} alt="" />
            </div>
          </div>
        </Wrapper>
      </Ripples>
      {popup ? (
        <>
          <Overlay
            onClick={() => {
              setPopup(false);
            }}
          ></Overlay>
          <Popup>
            <div className="modal">
              <div className="flex flex-row px-4">
                <div className="flex flex-col gap-2 py-4 date-a11y">
                  {dateOptions.map((day) => {
                    return (
                      <Ripples color="#0061FF40" during={600} key={day.days}>
                        <span
                          onClick={() => {
                            daySelectHandler(day.days);
                          }}
                          className={` dateshde text-center ${
                            dateA11y === day.days ? "date-active" : ""
                          }`}
                        >
                          {day.title}
                        </span>
                      </Ripples>
                    );
                  })}
                </div>
                <div className="w-full h-full">
                  <DatePicker
                    wrapperClassName="datepicker"
                    selected={startDate}
                    onChange={onCalendarChange}
                    startDate={startDate}
                    endDate={endDate}
                    selectsRange
                    showMonthYearPicker
                    inline
                    maxDate={addDays(new Date(), -1)}
                    minDate={minDate}
                    locale={mn}
                    disabledKeyboardNavigation
                  />
                </div>
              </div>
              <div className="flex flex-row date-clear-field justify-between p-4 items-center">
                <div className="flex flex-row gap-1">
                  <IconController
                    src={assets.svg.calendarClear}
                    className="w-4 h-4"
                  />
                  <h5 className="text-xs font-medium">
                    {selectedStartDate} - {selectedEndDate}
                  </h5>
                </div>
                <div className="flex flex-row gap-2">
                  <Ripples
                    color="#0061FF40"
                    during={600}
                    className="rounded-3xl"
                  >
                    <div
                      className="clear-button"
                      onClick={() => {
                        clearHandler();
                      }}
                    >
                      <span className="text-xs">Цэвэрлэх</span>
                    </div>
                  </Ripples>
                  <Ripples
                    color="#ffffff40"
                    during={600}
                    className="rounded-3xl"
                  >
                    <div
                      className={` ${
                        canSort ? "sort-button" : "sort-button-disabled"
                      }`}
                      onClick={() => {
                        sortHandler();
                      }}
                    >
                      <span className="text-xs">Ангилах</span>
                    </div>
                  </Ripples>
                </div>
              </div>
            </div>
          </Popup>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default DateSelectDropdown;
